import React from 'react';

import MRadioGroupView from './MRadioGroup.view';

import { MRadioOption } from './MRadioGroup.model';

type Props = {
  value: string | null;
  name: string;
  options: MRadioOption[];
  display?: 'col' | 'row';
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
};

const MRadioGroup: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MRadioGroupView
      options={props.options}
      name={props.name}
      value={props.value}
      display={props.display}
      disabled={props.disabled}
      className={props.className}
      labelClassName={props.labelClassName}
      onChange={props.onChange}
    >
      {props.children}
    </MRadioGroupView>
  );
};

MRadioGroup.displayName = 'MRadioGroup';
MRadioGroup.defaultProps = {};

export default MRadioGroup;
